export default __webpack_public_path__ + "src/openspace/assets/png/carbon.oken.webp";
export const Scaled = {
    "0.5x": __webpack_public_path__ + "src/openspace/assets/png/carbon.oken.webp",
    "1x": __webpack_public_path__ + "src/openspace/assets/png/carbon.oken.webp",
    "2x": __webpack_public_path__ + "src/openspace/assets/png/carbon.oken.webp",
    "3x": __webpack_public_path__ + "src/openspace/assets/png/carbon.oken.webp",
    "4x": __webpack_public_path__ + "src/openspace/assets/png/carbon.oken.webp"
}